const o = {
  dock: '',
  expect_space: '',
  item_num: '',
  item_unit: '',
  lessor: '[]',
  near_land: '',
  near_land_other: '',
  note: '',
  rent_end_date: '',
  rent_space: '',
  rent_start_date: '',
  sign_status: '',
  unit_area: '',
};
export default o;
